module.exports = __webpack_public_path__ + "img/candles_select@2x.35101096.svg";